import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { colorsPalette, SMALL_MARGIN, LARGE_MARGIN, MIDDLE_MARGIN, BIG_MARGIN } from '../../theme';

const useStyles = (background) =>
  makeStyles((theme: Theme) => {
    const bgColor =
      background === 'Dark' ? theme.palette.secondary.dark : theme.palette.secondary.light;

    return createStyles({
      wrapper: {
        color: colorsPalette.white,
        position: 'relative',
        overflow: 'hidden',
        background: bgColor,
        [theme.breakpoints.up('md')]: {
          display: 'flex',
          padding: 0,
        },
      },
      halfWidthImg: {
        overflow: 'hidden',
        position: 'relative',
        '&:after': {
          content: '""',
          display: 'block',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `linear-gradient(180deg, rgba(35, 32, 46, 0.52) 52.18%, ${bgColor} 88.64%)`,
          '-webkit-background-origin': 'padding-box',
          '-o-background-origin': 'padding-box',
          '-moz-background-origin': 'padding-box',
        },
        '& img': {
          minHeight: '100%',
          minWidth: '100%',
        },
        [theme.breakpoints.down('sm')]: {
          height: 360,
        },
        [theme.breakpoints.down('xs')]: {
          height: 280,
        },
        [theme.breakpoints.up('md')]: {
          position: 'absolute',
          maxWidth: '50vw',
          left: 0,
          right: '50vw',
          top: 0,
          bottom: 0,
          '&:after': {
            background: `linear-gradient(90deg, rgba(35, 32, 46, 0.1) 37.59%, ${bgColor} 95.39%)`,
          },
        },
      },
      content: {
        padding: `${MIDDLE_MARGIN}px ${SMALL_MARGIN}px`,
        position: 'relative',
        marginTop: '-100px',
        [theme.breakpoints.up('md')]: {
          marginTop: 0,
          left: '50vw',
          maxWidth: '50vw',
          width: '50vw',
          padding: `${LARGE_MARGIN}px 20px ${LARGE_MARGIN}px ${MIDDLE_MARGIN}px`,
        },
      },
      heading: {
        marginBottom: SMALL_MARGIN,
        fontSize: 24,
        lineHeight: 1.4,
        [theme.breakpoints.up('md')]: {
          marginBottom: MIDDLE_MARGIN,
          fontSize: 28,
          maxWidth: 560,
        },
      },
      items: {
        marginTop: 22,
        width: '100%',
        [theme.breakpoints.up('md')]: {
          marginTop: MIDDLE_MARGIN,
          maxWidth: 560,
        },
      },
      item: {
        display: 'flex',
        alignItems: 'center',
        '&:not(:last-child)': {
          marginBottom: MIDDLE_MARGIN,
          [theme.breakpoints.up('xl')]: {
            marginBottom: BIG_MARGIN,
          },
        },
        '&:hover': {
          textDecoration: 'none',
          '& $itemIcon': {
            color: colorsPalette.violet,
          },
        },
      },
      itemIcon: {
        width: 16,
        height: 16,
        transform: 'rotate(90deg)',
        marginTop: 6,
        transition: 'color .3s',
        [theme.breakpoints.up('md')]: {
          width: 20,
          height: 20,
        },
      },
      imageWrap: {
        width: 36,
        height: 36,
        flexShrink: 0,
        [theme.breakpoints.up('md')]: {
          width: 54,
          height: 54,
        },
        '& img': {
          width: '100%',
          maxHeight: '100%',
        },
      },
      textWrapper: {
        flex: 2,
        paddingLeft: SMALL_MARGIN,
        [theme.breakpoints.up('md')]: {
          paddingLeft: MIDDLE_MARGIN,
        },
      },
      itemTitle: {
        fontSize: 18,
        lineHeight: 1.4,
        color: colorsPalette.white,
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        [theme.breakpoints.up('md')]: {
          fontSize: 20,
          marginBottom: 10,
        },
      },
      itemText: {
        fontSize: 16,
        lineHeight: 1.4,
        color: colorsPalette.violet,
      },
    });
  });

export default useStyles;
